module.exports = __webpack_public_path__ + "img/icon-mail-gray.0d98f368.svg";